import { __exports as t } from "../../../../_virtual/findDOMNode.mjs";
import "../../../@babel/runtime/helpers/interopRequireDefault.mjs";
import "../../../@babel/runtime/helpers/typeof.mjs";
import l from "react";
import u from "react-dom";
import { exports as m } from "../../../../_virtual/interopRequireDefault.mjs";
import { exports as d } from "../../../../_virtual/typeof.mjs";
var n = m.default;
Object.defineProperty(t, "__esModule", {
  value: !0
});
t.default = v;
var g = t.getDOM = i;
t.isDOM = r;
var p = n(d), s = n(l), f = n(u);
function r(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function i(e) {
  return e && (0, p.default)(e) === "object" && r(e.nativeElement) ? e.nativeElement : r(e) ? e : null;
}
function v(e) {
  var a = i(e);
  if (a)
    return a;
  if (e instanceof s.default.Component) {
    var o;
    return (o = f.default.findDOMNode) === null || o === void 0 ? void 0 : o.call(f.default, e);
  }
  return null;
}
export {
  g as getDOM
};
//# sourceMappingURL=findDOMNode.mjs.map
